import { Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { hostValidationRegexp, localHostValidationRegExp } from 'src/utils/validations';

const HostInputComponent: React.FC<any> = ({
    host,
    isValidHost,
    addNewHost,
    setHost,
    setIsValidHost,
    client,
}: any) => {
    const { t } = useTranslation();
    const handleInputChange = (e: any) => {
        setHost(e.target.value);
        setIsValidHost(
            (hostValidationRegexp.test(e.target.value) ||
                localHostValidationRegExp.test(e.target.value)) &&
                client!.hosts.indexOf(e.target.value) === -1 &&
                e.target.value.length >= 1,
        );
    };
    const handleOnEnter = (e: any) => {
        if (e.keyCode === 13 && isValidHost) {
            addNewHost();
        }
    };
    return (
        <Grid item xs={9}>
            <TextField
                sx={{ width: '100%' }}
                id="standard-basic"
                label={t('domain')}
                placeholder="www.example.ro"
                variant="standard"
                value={host}
                error={!isValidHost}
                onChange={handleInputChange}
                onBlur={handleInputChange}
                onKeyDown={handleOnEnter}
            />
        </Grid>
    );
};

export default HostInputComponent;
